import React from 'react';
import ReactQueryParams from 'react-query-params';
import {BrowserRouter, Route, Switch } from "react-router-dom";
import {Elements, StripeProvider} from 'react-stripe-elements'; //pk_live_EVLV4gA1dOPaQ6HkYmltAJft  //pk_test_oiKt1MpvD3aeJypmJzgrNi4h
import { useAuth0 } from "./react-auth0-wrapper";

import './App.css';
import Transactions from './Transactions.js';
import Accounts from './Accounts.js';
import NavBar from './NavBar.js';
import Analysis from './Analysis.js';
import PrivateRoute from "./PrivateRoute";
import Loading from './Loading.js';

const App = () => {
  const { loading } = useAuth0();
  if (loading) {
    return <Loading />;
  }
  return (
    <BrowserRouter>
    <div className="App">
    <StripeProvider apiKey="pk_live_EVLV4gA1dOPaQ6HkYmltAJft"> 
    <div>
      <header className="App-header">
        <h1 className="App-title">API Bank</h1>
        <NavBar />
      </header>
      <Switch>
        <Route exact path="/" component={Home} />
        <PrivateRoute path="/transactions" component={Transactions}/> 
        <PrivateRoute path="/accounts" component={Accounts}/> 
        <PrivateRoute path="/analysis" component={Analysis}/> 
      </Switch>
    </div>
    </StripeProvider>
    </div>
    </BrowserRouter>
  );
}

const Home = () => {
  return <div>API Bank offers multibanking with <br/> Revolut, Monzo, Starling and all big UK Banks. <br/> German Banks are coming soon...</div>;
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js